import { iconUri } from '@nerdwallet/nw-client-lib/cdn';
import { ApplyNowLink } from '@nerdwallet/react-apply-now';

import {
  getRefinanceFreeCreditScore,
  HOME_LIGHT_IMPRESSION,
} from '../../lib/analytics-constants';
import registerLink from '../../lib/register-link';

export default [
  {
    header: 'Rates',
    text: 'A low rate can save you hundreds each year.',
    img: iconUri('House_pricetag'),
    alt: 'House with price tag',
    link: {
      url: '/mortgages/refinance-rates?trk_source=mortgages_rc_toolcard&trk_content=rates_card_pos1&trk_destination=refinance-rates&trk_origin=refinance-calculator&trk_app=tool&loanDuration={{0}}',
      text: 'Compare mortgage rates',
    },
    keys: [
      {
        key: 'inputs.howLongStay',
      },
    ],
  },
  {
    header: 'Credit',
    text: 'See how a mortgage impacts your score.',
    img: iconUri('Credit_score'),
    alt: 'Credit score gauge',
    link: registerLink(
      'rc',
      {
        element: 'ad_unit',
        location: 'toolcard_card+pos2',
      },
      'Get your free credit score'
    ),
    impressionEventPayload: getRefinanceFreeCreditScore(),
  },
  {
    header: 'Lenders',
    text: 'Get your true budget and find a home with ease.',
    img: iconUri('Approval'),
    alt: 'Thumbs up with dollar sign',
    link: {
      url: '/mortgages/mortgage-pre-approval/?trk_source=mortgages_rc_toolcard&trk_content=preapproval_toolcard_card+pos3&trk_destination=mortgage-pre-approval&trk_origin=refinance-calculator&trk_app=tool&loanPurpose=refinance&loanDuration={{0}}',
      text: 'Get preapproved',
    },
    keys: [
      {
        key: 'inputs.howLongStay',
      },
    ],
  },
  {
    header: 'Agents',
    text: 'Get matched with a top agent in your area.',
    img: iconUri('Real_estate_1'),
    alt: 'Real estate sign',
    link: {
      linkComponent: ApplyNowLink,
      text: 'Find a real estate agent',
      props: {
        linkType: 'apply_now_button',
        logImpression: false,
        link: '/redirect/eeadcaf6-38db-11eb-a727-ef6ff84e35fe',
      },
      getAdditionalProps: (impressionData: any): { impressionId: string } => ({
        impressionId: impressionData?.impressionId,
      }),
    },
    impressionEventPayload: {
      ...HOME_LIGHT_IMPRESSION,
      payload: {
        ...HOME_LIGHT_IMPRESSION.payload,
        section_name: 'mortgages_refinance_tool_card',
        section_position: 7,
      },
    },
  },
];
